import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, finalize, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoadingService } from '../services/loading.service';
import { keys } from '../constants/keys';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  totalRequests = 0;
  requestsCompleted = 0;
  constructor(private loadingService: LoadingService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this.totalRequests++;
    this.loadingService.setLoading(true);

    // edit request
    request = request.clone({
      setHeaders: {
        IntegrationKey: keys.IntegrationKey,
      },
    });

    var modifiedRequest = request.clone({
      withCredentials: true,
    });

    return next.handle(modifiedRequest).pipe(
      finalize(() => {
        this.requestsCompleted++;
        if (this.requestsCompleted === this.totalRequests) {
          this.loadingService.setLoading(false);
          this.totalRequests = 0;
          this.requestsCompleted = 0;
        }
      }),
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (
              err.status === 401 ||
              err.status === 403 ||
              err.status === 302
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        },
      ),
    );
  }
}
